// removed by extract-text-webpack-plugin
module.exports = {"overlay":"style__overlay___2MMyO","overlayModal":"style__overlayModal___3Zs0e","overlayModalInner":"style__overlayModalInner___12NxH","overlayCloseButton":"style__overlayCloseButton___QhS1F","overlayModalTitle":"style__overlayModalTitle___1W9SJ","overlayModalText":"style__overlayModalText___U3vAJ","overlayModalTextBold":"style__overlayModalTextBold___2OarN","overlayModalButtons":"style__overlayModalButtons___3Trfe","overlayModalButtonsItem":"style__overlayModalButtonsItem___1QSoT","overlayModalButtonsItemButton":"style__overlayModalButtonsItemButton___BQ1wv","buttonActive":"style__buttonActive___2OT7_"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modal-imagetags/style.css
// module id = 809
// module chunks = 0